// Generated by _workspace/uncalled_filter.py. Do not edit by hand.
export const called_house_races = [
  'CA-5692',
  'CA-5693',
  'CA-5695',
  'CA-5696',
  'CA-5698',
  'CA-5699',
  'CA-5702',
  'CA-5703',
  'CA-5705',
  'CA-5706',
  'CA-5707',
  'CA-5708',
  'CA-5709',
  'CA-5710',
  'CA-5711',
  'CA-5712',
  'CA-5714',
  'CA-5715',
  'CA-5716',
  'CA-5717',
  'CA-5718',
  'CA-5720',
  'CA-5721',
  'CA-5722',
  'CA-5723',
  'CA-5725',
  'CA-5726',
  'CA-5727',
  'CA-5728',
  'CA-5729',
  'CA-5731',
  'CA-5732',
  'CA-5733',
  'CA-5734',
  'CA-5735',
  'CA-5736',
  'CA-5741',
  'CA-5742',
  'CA-6235',
  'CA-6478',
  'CA-7296',
  'CA-8514',
  'CA-8725',
];
export const called_senate_races = [
  'CA-5848',
  'CA-5849',
  'CA-5855',
  'CA-5856',
  'CA-5857',
  'CA-5860',
  'CA-5861',
  'CA-5863',
  'CA-6484',
];
export const called_assembly_races = [
  'CA-5154',
  'CA-5258',
  'CA-5465',
  'CA-5763',
  'CA-5765',
  'CA-5767',
  'CA-5769',
  'CA-5771',
  'CA-5774',
  'CA-5775',
  'CA-5776',
  'CA-5777',
  'CA-5778',
  'CA-5779',
  'CA-5780',
  'CA-5781',
  'CA-5782',
  'CA-5783',
  'CA-5784',
  'CA-5786',
  'CA-5787',
  'CA-5788',
  'CA-5789',
  'CA-5791',
  'CA-5792',
  'CA-5794',
  'CA-5798',
  'CA-5800',
  'CA-5801',
  'CA-5802',
  'CA-5804',
  'CA-5807',
  'CA-5808',
  'CA-5809',
  'CA-5811',
  'CA-5812',
  'CA-5813',
  'CA-5815',
  'CA-5816',
  'CA-5818',
  'CA-5819',
  'CA-5823',
  'CA-5824',
  'CA-5826',
  'CA-5827',
  'CA-5840',
  'CA-5841',
  'CA-5842',
  'CA-8965',
];
export const called_statewide_races = [
  'CA-6480',
  'CA-6481',
  'CA-6482',
  'CA-6483',
  'CA-6488',
];
export const called_shared_races = ['sheriff-4348'];
export const called_propositions = [
  'CA-84431',
  'CA-84432',
  'CA-84433',
  'CA-84436',
  'CA-84438',
  'CA-84443',
];
